import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: var(--spacing-03);
  border: 1px solid var(--coolest-gray-20);
  background-color: var(--coolest-gray-10);
  border-radius: var(--border-radius-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface Props {
  appId: number;
  uniqueId: string;
  editor: Editor;
}
export const AIFillAppResolvedContent: FC<Props> = () => {
  return <Wrapper />;
};
